import styled from 'styled-components'

export const Table = styled.table`
  width: ${({ width }) => width || '100%'};
  margin: 0 auto;
  border-collapse: separate;
  border-spacing: 0;
  background: ${props => props.theme.colors.background.primary};
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.semantic.primary + '26'};
  box-shadow: 0 3px 14px ${props => props.theme.colors.semantic.primary + '12'};
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 5px 18px ${props => props.theme.colors.semantic.primary + '18'};
  }
`

export const Thead = styled.thead`
  transition: all 0.3s ease;

  tr {
    background: ${props => props.theme.colors.semantic.primary + '08'};
  }

  tr td {
    color: ${props => props.theme.colors.semantic.primary + 'B8'};
    border-bottom: 1px solid ${props => props.theme.colors.semantic.primary + '24'};
  }

  td {
    padding: ${({ $compact }) => $compact ? '0.35rem 0.6rem' : '0.7rem 0.75rem'};
    font-weight: 600;
    font-size: 0.68rem;
    font-family: ${props => props.theme.typography.fontFamily};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: none;
    white-space: nowrap;

    &:first-child {
      border-top-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
    }
  }
`

export const Tbody = styled.tbody`
  tr {
    transition: background 0.2s ease;

    &:hover {
      background: ${props => props.theme.colors.semantic.primary + '08'};
    }

    &:last-child td {
      border-bottom: none;
    }
  }
`

export const Trow = styled.tr`
  background: ${props => props.theme.colors.background.primary};
  transition: background 0.3s ease;

  td {
    border-bottom: 1px solid ${props => props.theme.colors.semantic.primary + '1A'};
    transition: border-color 0.3s ease;
  }
`

export const Tcol = styled.td`
  padding: ${({ $compact }) => $compact ? '0.35rem 0.6rem' : '0.65rem 0.75rem'};
  text-align: ${({ align }) => align || 'left'};
  color: ${props => props.theme.colors.text.secondary};
  font-size: 0.82rem;
  font-weight: 400;
  font-family: ${props => props.theme.typography.fontFamily};
  vertical-align: middle;
  line-height: 1.3;
  transition: color 0.3s ease;

  &:has(svg) {
    cursor: pointer;
  }

  svg {
    color: ${props => props.theme.colors.semantic.primary};
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.15);
      color: ${props => props.theme.colors.semantic.primary};
    }
  }
`
